import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number;
  backend_apis: number; database_tables: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; recommendations_generated: boolean; priorities_ranked: boolean;
  evidence_attached: boolean; reasoning_explainable: boolean;
  executive_reports_operational: boolean; marketplace_dna_consumed: boolean;
  knowledge_graph_integrated: boolean; learning_updates_operational: boolean; gaps?: string[];
};

export type Dev110Status = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  marketplace_operating_brain: boolean; production_ready: boolean; dna_integrated: boolean;
  knowledge_graph_integrated: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const marketplaceBrainDev110Api = {
  dashboard: () => fetchG<SprintDashboard>('/dev110/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/dev110/objectives').then((r) => r.objectives),
  intelligenceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/dev110/intelligence-modules').then((r) => r.modules),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/dev110/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/dev110/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/dev110/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/dev110/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Dev110Status>('/dev110/status'),
};
